export default class CustomModal extends window.HTMLElement {
  dialog: HTMLDialogElement | null = null;
  overlay: HTMLDivElement | null = null;
  panel: HTMLDivElement | null = null;
  toggleBtn: HTMLElement | null = null;

  constructor() {
    super();
    this.dialog = this.querySelector('[id*="-dialog"]');
    this.overlay = this.querySelector('[id*="-overlay"]');
    this.panel = this.querySelector('[id*="-panel"]');
    this.toggleBtn = this.querySelector('[id*="-toggle"]');

    const closeBtns = this.querySelectorAll('[data-custom-modal-close]');

    this.toggleBtn?.addEventListener('click', this.show.bind(this));

    closeBtns.forEach((btn) => {
      btn.addEventListener('click', this.close.bind(this));
    });

    this.overlay?.addEventListener('click', this.close.bind(this));

    // Intercept native Escape close
    this.dialog?.addEventListener('cancel', (e) => {
      e.preventDefault(); // stop auto-close
      this.close(); // use animated version
    });
  }

  show = () => {
    window.scrollLock();
    this.dialog?.showModal();
    // Support bottom sheet on mobile (translate-y) and drawer on desktop (translate-x)
    if (this.panel) {
      this.panel.classList.remove('translate-y-full');
      this.panel.classList.remove('m:translate-x-full');
      this.panel.classList.add('translate-y-0');
      this.panel.classList.add('m:translate-x-0');
    }
  };

  close() {
    window.scrollUnlock();
    if (this.panel) {
      this.panel.classList.remove('translate-y-0');
      this.panel.classList.remove('m:translate-x-0');
      this.panel.classList.add('translate-y-full');
      this.panel.classList.add('m:translate-x-full');
    }

    setTimeout(() => {
      this.dialog?.close();
    }, 300);
  }
}

if (!customElements.get('custom-modal')) {
  customElements.define('custom-modal', CustomModal);
}
